import _classCallCheck from "/Users/elias/Desktop/Bureau/DocUp - vide\u0301o/Site Web /Superprops copie/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/Users/elias/Desktop/Bureau/DocUp - vide\u0301o/Site Web /Superprops copie/node_modules/@babel/runtime/helpers/esm/createClass.js";
export var PolygonMaskLocalSvg = /*#__PURE__*/function () {
  function PolygonMaskLocalSvg() {
    _classCallCheck(this, PolygonMaskLocalSvg);

    this.path = [];
    this.size = {
      height: 0,
      width: 0
    };
  }

  _createClass(PolygonMaskLocalSvg, [{
    key: "load",
    value: function load(data) {
      if (!data) {
        return;
      }

      if (data.path !== undefined) {
        this.path = data.path;
      }

      if (data.size !== undefined) {
        if (data.size.width !== undefined) {
          this.size.width = data.size.width;
        }

        if (data.size.height !== undefined) {
          this.size.height = data.size.height;
        }
      }
    }
  }]);

  return PolygonMaskLocalSvg;
}();